import React, { useEffect, useMemo, useState } from 'react'
import Sidebarlayout from '../../Layouts/Sidebarlayout'
import { useLocation, useNavigate } from 'react-router-dom'
import '../../Assets/Css/ViewInvoice.scss'
import Table from '../../Components/Table'
import Select from 'react-select';
import UserAvatar from 'react-user-avatar';
import { Link } from 'react-router-dom'
import { getCurrencyList, getSingleInvoice, getSystemSettings, updateInvoiceStatus } from '../../Services/Invoices/action'
import { connect } from 'react-redux'
import moment from 'moment';
import { toast } from "react-toastify";
import { getAuthHeader } from "../../Lib/utils";
import { api } from "../../Lib/constants";
import { Spinner } from "react-bootstrap";
import { number } from 'yup'

const colourOptions = [
    { value: 'Draft', label: 'pending', color: '#E46A76' },
    { value: 'Sent', label: 'inprogress', color: '#03C9D7' },
    { value: 'Partially Paid', label: 'partially-pay', color: '#FEC90F' },
    { value: 'Paid', label: 'success', color: '#00C292' }
];

const ViewInvoice = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const data = location.state.data;
    const [viewData, setViewData] = useState({});
    const [invoiceStatus, setInvoiceStatus] = useState(null);
    const [exportLoading, setExportrLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [currencycode, setCurrencyCode] = useState("");
    const [defaultcurrency, setDefaultCurrency] = useState("")
    const [currencyrate, setCurrencyRate] = useState("")
    const [defaultcurrencysymbol, setDefaultCurrencySymbol] = useState("");
    const [currencysymbol, setCurrencySymbol] = useState("");
    const [RemainingAmount, setRemainingAmount] = useState("");

    console.log(viewData?.invoiceTransactionMap, "---data----");

    const getInvoiceData = async () => {
        try {
            await props.getSingleInvoice(data.invoiceId.value);
            await props.getCurrencyList();
            await props.getSystemSettings();
        } catch (error) {
            console.log("Error", error);
        }
    }

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            const DefaultCurrencyCode = await props?.systemsettings?.find((item) => item?.key)?.value;

            const CurrencyCode = await props?.currencylist?.find((item) => item?.id === props?.invoiceDetails?.currency_id)?.code

            const DefaultCurrencySymbol = await props?.currencylist?.find((item) => item.code === DefaultCurrencyCode)?.symbol;

            const CurrencySymbol = await props?.currencylist?.find((code) => code?.id === props?.invoiceDetails?.currency_id)?.symbol

            const CurrencyRate = await props?.invoiceDetails?.currency_rate;

            const TotalCreditAmountObj = await viewData?.invoiceTransactionMap?.filter((value) => value?.transactionInvoiceMap?.type === "credit");

            const TotaldebitAmountObj = await viewData?.invoiceTransactionMap?.filter((value) => value?.transactionInvoiceMap?.type === "debit");

            const CreditAmountSum = await TotalCreditAmountObj?.reduce((acc, item) => {
                const data = Number(item?.amount)
                return acc + data
            }, 0)

            const DebitAmountSum = await TotaldebitAmountObj?.reduce((acc, item) => {
                const data = Number(item?.amount)
                return acc + data
            }, 0)

            const RemainingAmount = CreditAmountSum - DebitAmountSum;


            setDefaultCurrency(DefaultCurrencyCode);
            setCurrencyCode(CurrencyCode);
            setCurrencySymbol(CurrencySymbol);
            setDefaultCurrencySymbol(DefaultCurrencySymbol);
            setCurrencyRate(CurrencyRate);
            setIsLoading(false);
            setRemainingAmount(RemainingAmount);
        })()

    }, [props.systemsettings, props.currencylist, props.currencylist])

    useEffect(() => {
        if (data?.invoiceId.value) {
            getInvoiceData();
        } else {
            toast.error("Something Went Wrong !");
            navigate("/invoice");
        }
    }, []);

    useEffect(() => {
        setTheData();
    }, [props.loading])

    const setTheData = async () => {
        if (props.invoiceDetails) {
            const myData = await props.invoiceDetails;
            setViewData(myData);
            const statusVal = colourOptions.filter((option) => {
                return option.value === myData?.status;
            });
            setInvoiceStatus(statusVal[0]);
        }
    }

    const dot = (color) => {
        if (color === void 0) {
            color = 'transparent';
        }
        return ({
            alignItems: 'center',
            display: 'flex',
            ':before': {
                content: '" "',
                backgroundColor: color,
                borderRadius: 10,
                display: 'block',
                marginRight: 8,
                height: 10,
                width: 10,
            },
        });
    };

    const colourStyles = {
        control: (styles) => ({ ...styles, backgroundColor: 'white' }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            const color = data.color;
            return {
                ...styles,
                flexWrap: 'nowrap !important',
                wordWrap: 'nowrap !important',
                ':active': {
                    ...styles[':active'],
                    backgroundColor: !isDisabled
                        ? isSelected
                            ? data.color
                            : color
                        : undefined,
                },
            };
        },
        input: (styles) => ({ ...styles, ...dot() }),
        placeholder: (styles) => ({ ...styles, ...dot('#ccc') }),
        singleValue: (styles, { data }) => ({ ...styles, ...dot(data.color), color: data.color }),
        container: style => ({
            ...style,
            width: '100%'
        }),
        indicatorSeparator: style => ({
            ...style,
            display: 'none'
        }),
        valueContainer: (base) => {
            let newbase = {
                ...base,
                flex: '0 0 auto',
                padding: '0px'
            }
            return newbase
        },
        input: (base) => {
            let newBase = {
                ...base,
                flex: '0 0 auto',
                gridArea: '1/1/1/1'
            }
            return newBase;
        },
        control: (base) => ({
            ...base,
            flexWrap: 'nowrap !important',
            border: '0 !important',
            outline: '0 !important',
            boxShadow: '0 !important',
            '&:hover': {
                border: '0 !important',
                outline: '0 !important'
            }
        })

    };

    const headerInvoiceItem = [
        { field: 'Description' },
        { field: 'Rate(INR)' },
        { field: 'Rate(~)' },
        { field: 'Quantity' }
    ];

    const headerInvoiceAmount = [
        { field: 'SubTotal' },
        { field: 'Discount' },
        { field: 'Taxes' },
        { field: 'Total' },
        { field: 'Total(~)' },
    ];

    const headerShareHolder = [
        { field: 'Name' },
        { field: 'Role' },
        { field: 'Mobile' }
    ];

    const headerTransaction = [
        { field: 'Type' },
        { field: 'Date' },
        { field: 'Description' },
        { field: 'Amount(INR)' },
        { field: 'Invoice Amount(INR)' },
    ];

    const headerTaxes = [
        { field: 'Name' },
        { field: 'Percentages' },
        { field: 'Amount(INR)' },
        { field: 'Amount(~)' },
    ];

    const dataTaxes = viewData?.invoiceTaxMap?.map(taxes => {
        const discount = viewData?.discount_type === "fixed" ? viewData?.discount : (viewData?.subtotal * (viewData?.discount / 100));

        const dataTaxesountRateAllCurrency = currencycode === defaultcurrency ?
            "-"
            :
            `${currencysymbol || ""} ${parseFloat((viewData?.subtotal - discount) * (taxes?.taxInvoiceMap?.percent / 100) || 0).toFixed(2)}`;

        return {
            Name: {
                value: taxes?.taxInvoiceMap?.name,
                type: 'text'
            },
            Percentages: {
                value: `${taxes?.taxInvoiceMap?.percent || 0} %`,
                type: 'text'
            },
            "Amount(INR)": {
                value: `${defaultcurrencysymbol || ""}${parseFloat((viewData?.subtotal - discount) * (taxes?.taxInvoiceMap?.percent / 100) * currencyrate || 0).toFixed(2) || 0}`,
                type: 'amount'
            },
            "Amount(~)": {
                value: dataTaxesountRateAllCurrency,
                type: 'amount'
            }
        }
    })

    const dataTransaction = viewData?.invoiceTransactionMap?.map(items => {
        const transactionType = items?.transactionInvoiceMap?.type === "credit" ? "credited" : "debited"

        return ({
            Type: {
                value: transactionType,
                type: items?.transactionInvoiceMap?.type
            },
            Date: {
                value: moment(items?.transactionInvoiceMap?.created_at).format('DD/MM/yyyy'),
                type: 'date'
            },
            Description: {
                value: items?.transactionInvoiceMap?.description,
                type: 'description'
            },
            "Amount(INR)": {
                value: `${defaultcurrencysymbol || ""} ${items?.transactionInvoiceMap?.amount || 0}`,
                type: 'text'
            },
            "Invoice Amount(INR)": {
                value: `${defaultcurrencysymbol || ""} ${parseFloat(items.amount).toFixed(0) || 0}`,
                type: 'text'
            },
        })
    })

    const shareHolder = new Set();
    viewData?.invoiceTransactionMap?.forEach(invoiceTransaction => {
        invoiceTransaction?.transactionInvoiceMap?.transactionShareHolderMap?.forEach(tranShalehoder => {
            const shareHolderString = JSON.stringify(tranShalehoder?.shareHolderTransactionMap);
            shareHolder.add(shareHolderString);
        });
    });

    const dataShareHolder = Array.from(shareHolder)?.map(items => {
        items = JSON.parse(items);
        return {
            Name: {
                value: items?.name || "-",
                value2: items?.email || "-",
                src: '',
                type: 'client',
            },
            Mobile: {
                value: items?.mobile || "-",
                type: 'text'
            },
            Role: {
                value: items?.role?.name || "-",
                type: 'text'
            }
        }
    })

    const dataInvoiceAmountRateAllCurrency = currencycode === defaultcurrency ?
        "-"
        :
        `${currencysymbol || ""} ${viewData?.total || 0}`;

    const dataInvoiceAmount = [
        {
            SubTotal: {
                value: `${currencysymbol || ""}${viewData?.subtotal || 0}`,
                type: 'text'
            },
            Discount: {
                value: viewData?.discount_type === "fixed" ? `${currencysymbol || ""}${viewData?.discount || 0}` : `${viewData?.discount || 0}%`,
                type: 'text'
            },
            Taxes: {
                value: `${currencysymbol || ""}${viewData?.taxes || 0}`,
                type: 'text'
            },
            Total: {
                value: `${defaultcurrencysymbol || ""} ${viewData?.total * viewData?.currency_rate || 0}`,
                type: 'amount'
            },
            "Total(~)": {
                value: dataInvoiceAmountRateAllCurrency,
                type: 'amount'
            }
        }
    ];

    const dataInvoiceItem = viewData?.invoiceItems?.map(items => {
        const RateAllCurrency = currencycode === defaultcurrency ?
            "-"
            :
            `${currencysymbol || ""}${items.rate || 0}`;

        return ({
            Description: {
                value: items.description,
                type: 'description'
            },
            "Rate(INR)": {
                value: `${defaultcurrencysymbol || ""}${items.rate * currencyrate || 0}`,
                type: 'Rate',
            },
            "Rate(~)": {
                value: RateAllCurrency,
                type: 'Rate',
            },
            "Quantity": {
                value: items.qty || 0,
                type: 'qty',
            }
        })
    })
    let footer = false;

    const changeInvoiceStatus = async (e) => {
        try {
            setInvoiceStatus(e.value);
            await props.updateInvoiceStatus(data.invoiceId.value, e.value);
            getInvoiceData();
            toast.success("Status Updated Successfully");
        } catch (error) {
            toast.error("Error :", error);
        }
    }


    const showToastMessage = (error) => {
        toast.error(error, {
            position: toast.POSITION.TOP_RIGHT,
        });
    };

    const handleExport = async () => {
        setExportrLoading(true);
        await handlePdfDownload(data.invoiceId.value);
        toast.success("Download SuccessFully");
    }

    const handlePdfDownload = async (id) => {
        try {
            let result = await api(
                `invoices/generate/pdf`,
                "post",
                { ids: [id] },
                getAuthHeader(),
                { responseType: "blob" }
            );
            const url = window.URL.createObjectURL(result.data);
            downloadURI(url, `${id}.pdf`);
            setExportrLoading(false);
        } catch (error) {
            let errorMessage = error?.message;
            showToastMessage(errorMessage);
            setExportrLoading(false);
        }
    };

    function downloadURI(uri, name) {
        var link = document.createElement("a");
        link.download = name;
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }


    return (
        <Sidebarlayout>
            <div className='viewInvoice-main'>
                <div className="page-title">
                    <h4>View Invoice</h4>
                    <div className="edit-btn">
                        <button
                            className="custom-btn download-btn"
                            disabled={exportLoading}
                            onClick={(e) => {
                                e.preventDefault();
                                handleExport();
                            }}
                        >
                            {exportLoading ? (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            ) : (
                                "Download"
                            )}
                        </button>
                        <button type="button" className="custom-btn">
                            <Link to='/invoice/edit' style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data }}>
                                {props.loading ? (
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                ) : (
                                    "Edit"
                                )}</Link>
                        </button>
                    </div>
                </div>

                {props.loading ? <div style={{
                    display: "flex",
                    justifyContent: "center"
                }}>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                </div> : <div className="content-part">
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="left-part">
                                <div className="invoice-details">
                                    <div className="invoice-details-content">
                                        <h6 className='label'>Invoice No</h6>
                                        <h6 className='value'>{`#${viewData?.id}` || "-"}</h6>
                                    </div>
                                    <div className="invoice-details-content">
                                        <h6 className='label'>Title</h6>
                                        <h6 className='value'>{viewData?.title || "-"}</h6>
                                    </div>
                                    <div className="invoice-details-content">
                                        <h6 className='label'>Remaining Amount</h6>
                                        <h6 className='value'>{defaultcurrencysymbol || ""}{RemainingAmount || 0}</h6>
                                    </div>
                                    <div className="invoice-details-content">
                                        <h6 className='label'>Date</h6>
                                        <h6 className='value'>{viewData?.date || "-"}</h6>
                                    </div>
                                    <div className="invoice-details-content">
                                        <h6 className='label'>CurrencyCode</h6>
                                        <h6 className='value'>{currencycode || "-"}</h6>
                                    </div>
                                    <div className="invoice-details-content">
                                        <h6 className='label'>Amount(INR)</h6>
                                        <h6 className='value'>
                                            {defaultcurrencysymbol || ""}{viewData?.subtotal * currencyrate || 0}
                                        </h6>
                                    </div>
                                    <div className="invoice-details-content">
                                        <h6 className='label'>Amount(~)</h6>
                                        <h6 className='value'>
                                            {currencycode === defaultcurrency ?
                                                ("-") : (
                                                    ` ${currencysymbol || ""}${viewData?.subtotal || 0} `
                                                )}
                                        </h6>
                                    </div>
                                    <div className="invoice-details-content status-div">
                                        <h6 className='label'>Status</h6>
                                        <div>
                                            <Select
                                                defaultValue={invoiceStatus}
                                                value={invoiceStatus}
                                                options={colourOptions}
                                                styles={colourStyles}
                                                onChange={(e) => changeInvoiceStatus(e)}
                                            />
                                        </div>

                                    </div>
                                </div>
                                <div className="client-details">
                                    <div className="client-image">
                                        <UserAvatar src='' name={viewData.clientInvoices?.name || "-"} size='100' color='#f1f0f5' />
                                    </div>
                                    <div className="client-details-content">
                                        <h6 className='label'>Name</h6>
                                        <h6 className='value'>{viewData.clientInvoices?.name || "-"}</h6>
                                    </div>
                                    <div className="client-details-content">
                                        <h6 className='label'>Email</h6>
                                        <h6 className='value'>{viewData.clientInvoices?.email || "-"}</h6>
                                    </div>
                                    <div className="client-details-content">
                                        <h6 className='label'>Mobile</h6>
                                        <h6 className='value'>{viewData.clientInvoices?.mobile || "-"}</h6>
                                    </div>
                                    <div className="client-details-content">
                                        <h6 className='label'>Address</h6>
                                        <h6 className='value'>
                                            {`${viewData.clientInvoices?.address1} ${viewData.clientInvoices?.address2}, ${viewData.clientInvoices?.city}, ${viewData.clientInvoices?.state}, ${viewData.clientInvoices?.country}, ${viewData.clientInvoices?.postalcode},` || "-"}
                                        </h6>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-8">
                            <div className="right-part">
                                <div className="invoice-items">
                                    <h6 className='heading-title'>Invoice Items</h6>
                                    <Table header={headerInvoiceItem} footer={false} data={dataInvoiceItem || []} />
                                </div>
                                <div className="invoice-other-details">
                                    <div className="invoice-taxes">
                                        <h6 className='heading-title'>Invoice Taxes</h6>
                                        <div className='taxes-content'>
                                            <Table header={headerTaxes} data={dataTaxes || []} />
                                        </div>
                                    </div>
                                    <div className="invoice-amount">
                                        <h6 className='heading-title'>Invoice Amount</h6>
                                        <Table header={headerInvoiceAmount}
                                            data={dataInvoiceAmount}
                                            footer={footer} />
                                    </div>
                                </div>
                                <div className="transaction-details">
                                    <h6 className='heading-title'>Transaction Details</h6>
                                    <Table header={headerTransaction}
                                        data={dataTransaction || []}
                                        footer={false} />
                                </div>
                                <div className="shareholder-details">
                                    <h6 className='heading-title'>Share Holders Details</h6>
                                    <Table header={headerShareHolder}
                                        data={dataShareHolder}
                                        footer={false} />
                                </div>
                                <div className="invoice-notes">
                                    <h6 className="heading-title">Notes :</h6>
                                    <p>{viewData?.notes || "-"}</p>
                                </div>
                                <div className="invoice-term">
                                    <h6 className="heading-title">Term :</h6>
                                    {viewData?.invoiceTerms?.map((terms) => <p>{terms?.term}</p>)}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
            </div>
        </Sidebarlayout>
    )

}

const mapStateToProps = (state) => {
    return {
        invoiceDetails: state.invoicesReducer.invoiceDetails,
        loading: state.invoicesReducer.loading,
        currencylist: state.invoicesReducer.currencylist,
        systemsettings: state.invoicesReducer.systemsettings,
        transactionsList: state.transactionReducers.transactions.rows,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getSingleInvoice: (id) => dispatch(getSingleInvoice(id)),
        updateInvoiceStatus: (id, status) => dispatch(updateInvoiceStatus(id, status)),
        getCurrencyList: () => dispatch(getCurrencyList()),
        getSystemSettings: () => dispatch(getSystemSettings())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewInvoice);
